































import { Component, Vue } from 'vue-property-decorator';
import LoginService, { LoginResult } from '../../models/character/loginservice';
import * as api from './../../api/api';

@Component({
  components: {
  },
})
export default class LoginPage extends Vue {
  private isError = false;
  private isWarning = false;
  private isLogining = false;
  private errorMessage = '';
  private warningMessage = '';
  private loginId = '';
  private loginPassword = '';

  public abortLogin() {
    this.$router.push('home');
  }

  public login() {
    this.isLogining = true;
    this.isError = false;
    this.isWarning = false;
    LoginService.loginWithIdAndPasswordAsync(this.loginId, this.loginPassword)
      .then((result) => {
        switch (result) {
          case LoginResult.cannotConnect:
            this.errorMessage = 'サーバへの接続に失敗しました';
            break;
          case LoginResult.wrongIdOrPassword:
            this.errorMessage = 'IDまたはパスワードが間違っています';
            break;
          case LoginResult.emptyId:
            this.warningMessage = 'IDが入力されていません';
            this.isWarning = true;
            break;
          case LoginResult.emptyPassword:
            this.warningMessage = 'パスワードが入力されていません';
            this.isWarning = true;
            break;
          case LoginResult.invalidSecretKey:
            this.errorMessage = 'サーバのシークレットキーが不正です。管理者にお問い合わせください';
            break;
          case LoginResult.succeed:
            this.errorMessage = '';
            break;
          default:
            this.errorMessage = '不明なエラーが発生しました';
            break;
        }
        if (result === LoginResult.succeed) {
          this.$router.push('status');
        } else {
          if (!this.isWarning) {
            this.isError = true;
          }
          this.isLogining = false;
        }
      });
  }

  private mounted() {
    (this.$refs.firstFocused as any).focus();
  }
}
